import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appPhoneMask]',
    standalone: false
})
export class PhoneMaskDirective {
  mask = ['+', /[1-9]/, /\d/, ' ', /\d/, /\d/, ' ', /\d/,  /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = event.target.value.replace(/\D/g, '');
    const maskedValue = this.applyMask(value);

    this.control.control?.setValue(maskedValue, { emitEvent: false }); // Оновлюємо значення без тригеру подій
  }

  applyMask(value: string): string {
    let maskedValue = '';
    let index = 0;

    this.mask.forEach(maskChar => {
      if (index >= value.length) return;
      if (typeof maskChar === 'string') {
        maskedValue += maskChar;
      } else {
        maskedValue += value[index];
        index++;
      }
    });

    return maskedValue;
  }
}
